import { InMemoryCache } from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-client';
import { resolvers } from './resolvers';
import {
  restResourceCacheRedirects,
  batchRestResourceCacheRedirects,
} from './restResourceResolver/restResourceCacheRedirects';
import typeDefs from './schema.graphqls';

const cache = new InMemoryCache({
  cacheRedirects: {
    Query: {
      // Add cacheRedirects (https://www.apollographql.com/docs/react/advanced/caching/#cache-redirects-with-cacheredirects)
      // for any restResourceResolvers/batchRestResourceResolvers used as Query resolvers to ensure we can grab entities by
      // id
      ...restResourceCacheRedirects(resolvers.Query),
      ...batchRestResourceCacheRedirects(resolvers.Query),
    },
  },
});

export const client = new ApolloClient({
  cache,
  resolvers,
  typeDefs,
});
